import GuildInvitationNotification from './GuildInvitationNotification'
import React from 'react'
import GuildUserRemoved from './GuildUserRemoved'
import ServiceRequestDeliveryNotification from './ServiceRequestDeliveryNotification'
import ServiceRequestQuotationDeliveredNotification from './ServiceRequestQuotationDeliveredNotification'
import ServiceRequestCreatedNotification from './ServiceRequestCreatedNotification'
import GenericNotificationDisplay from './GenericNotificationDisplay'
import './NotificationItem.scss'
import GuildCreationNotification from './GuildCreationInvitation'
import {NotificationCategoryDTO, NotificationDTO} from '../../../../generated/api'

const NotificationItem = (notification: NotificationDTO): any => {
    const notificationItemGenerateMap = new Map<string, any>([])
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.GuildUserInvitation,
        <GuildInvitationNotification notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.UserRemovedFromGuild,
        <GuildUserRemoved notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.GuildCreationApproved,
        <GuildCreationNotification notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.GuildCreationDenied,
        <GuildCreationNotification notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.ServiceRequestCompleted,
        <ServiceRequestDeliveryNotification notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.ServiceRequestQuotationUpdate,
        <ServiceRequestQuotationDeliveredNotification notification={notification} />
    )
    notificationItemGenerateMap.set(
        NotificationCategoryDTO.ServiceRequestCreated,
        <ServiceRequestCreatedNotification notification={notification} />
    )
    return (
        (notification.category && notificationItemGenerateMap.get(notification.category)) ?? (
            <GenericNotificationDisplay notification={notification} title="Notification" canClose={true} />
        )
    )
}

export default NotificationItem
